import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATUS,
} from 'services/api';
import {
  AdvancedSearchItem,
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

import { TagsActionTypes } from './actions';
import { transformToTag } from '../transformations';

export const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

/**
 * Transforms search item received from server to our format
 * @param response
 */
export const transformSearch = (serverSearchItem: any): AdvancedSearchItem => {
  return {
    id: serverSearchItem.id,
    columns: serverSearchItem.columns,
    searchName: serverSearchItem.searchName,
    isDefault: serverSearchItem.isDefault,
  };
};

const fetchTagsReducer = createApiReducer(
  [
    TagsActionTypes.FETCH_TAGS_START,
    TagsActionTypes.FETCH_TAGS_SUCCESS,
    TagsActionTypes.FETCH_TAGS_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformToTag) }),
  (data) => data
);

const fetchSearchReducer = createFetchSearchReducer('tag');
const addSearchReducer = createAddSearchReducer('tag');
const updateSearchReducer = createUpdateSearchReducer('tag');
const deleteSearchReducer = createDeleteSearchReducer('tag');

const tagChainedReducers = chainReducers(initialState, fetchTagsReducer);

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  tags: tagChainedReducers,
  searches: searchChainedReducers,
});
